import React from 'react';
import { Link } from 'react-router';
const ConfigurableLink = ({
  link,
  className = undefined,
  activeClassName = undefined,
  isHardLink,
  routeNavigationConfirmation = null,
  children,
  onClick = undefined,
  dataLink = undefined,
  openInNewTab = undefined,
  tabIndex = 0,
  onBlur = undefined,
  onKeyDown = undefined
}) => {
  const handleBlur = () => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur();
  };
  return isHardLink ? /*#__PURE__*/React.createElement("a", {
    className: className,
    onClick: onClick,
    href: link,
    "data-link": dataLink,
    rel: "noreferrer",
    tabIndex: tabIndex,
    onKeyDown: onKeyDown
  }, children) : /*#__PURE__*/React.createElement(Link, {
    onClick: (...params) => {
      if (routeNavigationConfirmation) {
        routeNavigationConfirmation(link, onClick);
        params[0].preventDefault();
        return;
      }
      onClick && onClick(...params);
    },
    activeClassName: activeClassName,
    className: className,
    to: link,
    "data-link": dataLink,
    target: openInNewTab ? '_blank' : undefined,
    rel: openInNewTab ? 'noopener noreferrer' : '',
    onBlur: handleBlur,
    onKeyDown: onKeyDown,
    tabIndex: tabIndex
  }, children);
};
export { ConfigurableLink };